import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import theme from '~/theme';
import Icon from '~/components/base/Icon';

import { button } from '~/styles/buttons';
import BaseLink from '~/components/base/BaseLink';

const Link = styled(BaseLink)`
    ${button}
`;

const StyledButton = styled.button`
    ${button}
`;

const StyledSpan = styled.span`
    ${button};
`;

const Button = ({
    children,
    href,
    onClick,
    buttonType = 'default',
    external = false,
    className,
    useSpan = false,
    ...rest
}) => {
    const Tag = href ? Link : useSpan ? StyledSpan : StyledButton;

    return (
        <Tag
            {...{ onClick, buttonType, external, className }}
            to={href}
            {...rest}
        >
            {children}
            {buttonType === 'text' ? (
                <Icon
                    color={theme.palette.mediumBlue}
                    icon={'Arrow'}
                    size={24}
                />
            ) : null}
        </Tag>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    buttonType: PropTypes.oneOf(['default', 'white', 'outline', 'text']),
    external: PropTypes.bool,
    className: PropTypes.string,
    useSpan: PropTypes.bool
};

export default Button;
